import { toast } from 'sonner';

// sonner behind one module; <Toaster /> is mounted once in app/providers.tsx.
export const notify = {
  success: (message: string): void => {
    toast.success(message);
  },
  error: (message: string): void => {
    toast.error(message);
  },
};
